export const MENU_ITEM = {
  HOME: "home",
  CALENDAR: "calendar",
  MEMBERSHIP: "membership",
  TRIBE: "tribe",
  PROFILE: "profile",
};

export const APP_ROLE = "USER";
export const USER_TYPE = "WORKSPACE";
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const DATE_FORMAT = "DD MMM, YYYY";
export const BULLETIN_DATE_FORMAT = "MMM DD";
export const PAYMENT_DATE_FORMAT = "DD MMMM YYYY";
export const API_DATE_FORMAT = "YYYY-MM-DD";
export const PAYMENT_HISTORY_FORMAT = "MMM DD, YYYY";

export const PROFILE_STATUS = {
  NON_MEMBER: "NON_MEMBER",
  UNDER_REVIEW: "UNDER_REVIEW",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  MEMBER: "MEMBER",
};

export const PROFILE_STATUS_TYPE = [
  { name: "Non Member", value: "NON_MEMBER" },
  { name: "Under Review", value: "UNDER_REVIEW" },
  { name: "Payment Pending", value: "PAYMENT_PENDING" },
  { name: "Member", value: "MEMBER" },
];

export const MEMBER_BENEFITS_TYPE = {
  CLEAN_FUEL_CAFE: "CLEAN_FUEL_CAFE",
  INNOVATIVE_SPACE: "INNOVATIVE_SPACE",
  CREATIVE_SPACE: "CREATIVE_SPACE",
  EVENTS: "EVENTS",
  RETREAT: "RETREAT",
  COMMUNICATE_SPACE: "COMMUNICATE_SPACE",
  MB_STUDIO: "MB_STUDIO",
  WORKSHOP: "WORKSHOP",
  HOTLINE_HOURS: "HOTLINE_HOURS",
};

export const CALENDAR_RESERVATION_TYPE = {
  DF_WORKSPACE: "DF_WORKSPACE",
  MEETING_ROOMS: "MEETING_ROOMS",
  MB_STUDIO: "MB_STUDIO",
  EVENTS: "EVENTS",
  RETREAT: "RETREAT",
  INNOVATE_SPACE: "INNOVATE_SPACE",
  PASSES: "PASSES",
};

export const CALENDAR_RESERVATION_TABS = [
  {
    name: "Passes",
    value: "PASSES",
  },
  { name: "Creative Space", value: "DF_WORKSPACE" },
  {
    name: "Innovate Space",
    value: "INNOVATE_SPACE",
  },
  {
    name: "Communicate Space",
    value: "MEETING_ROOMS",
  },
];

export const MEETING_ROOM_TYPE = [
  { name: "1 Seater", value: "ONE_SEATER", count: 1 },
  {
    name: "2 Seater",
    value: "TWO_SEATER",
    count: 2,
  },
  {
    name: "3 Seater",
    value: "THREE_SEATER",
    count: 3,
  },
  {
    name: "4 Seater",
    value: "FOUR_SEATER",
    count: 4,
  },
];

export const MEMBERSHIP_TYPE = [
  { name: "Chrome", value: "CHROME" },
  {
    name: "Greyn",
    value: "GREYN",
  },
  {
    name: "Supreme",
    value: "SUPREME",
  },
  {
    name: "Nomad",
    value: "NOMAD",
  },
  {
    name: "Maven",
    value: "MAVEN",
  },
  {
    name: "Executive",
    value: "EXECUTIVE",
  },
];

export const MEMBERSHIP_PLAN_TYPE = [
  { name: "Quarterly", value: "QUARTERLY" },
  {
    name: "Half Yearly",
    value: "HALF_YEARLY",
  },
  {
    name: "Annually",
    value: "ANNUALLY",
  },
];

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
};

export const PURCHASE_TYPE = {
  EVENT: "EVENT",
  MEMBERSHIP: "MEMBERSHIP",
  CREDIT: "CREDIT",
};

export const GROUND_RULES = [
  "No Staring",
  "Speak Softly",
  "Follow Instructor’s Guidance.",
  "Silence Phone; Avoid Distractions",
];

export const FOCUS_RULES = [
  "Stay Quiet",
  "Take calls in the POD",
  "use Headphones",
  "Stick to Your Seat",
];

export const LaunchDateCleanFuelCafe = new Date("2026-04-01");
export const LaunchDateInnovativeSpace = new Date("2026-04-01");
export const LaunchDateCreativeSpace = new Date("2026-04-01");
export const LaunchDateCommunicateSpace = new Date("2026-04-15");
export const LaunchDateWorkspace = new Date("2026-03-18");
export const LaunchDateRetreat = new Date("2026-04-15");
export const LaunchDateMeetingRooms = new Date("2026-04-15");
export const LaunchDateMBStudio = new Date("2026-04-15");
